// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("assets/fonts/Inter/Inter-Thin.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("assets/fonts/Inter/Inter-ThinItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("assets/fonts/Inter/Inter-ExtraLight.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("assets/fonts/Inter/Inter-ExtraLightItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("assets/fonts/Inter/Inter-Light.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("assets/fonts/Inter/Inter-LightItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("assets/fonts/Inter/Inter-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("assets/fonts/Inter/Inter-Italic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("assets/fonts/Inter/Inter-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("assets/fonts/Inter/Inter-MediumItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("assets/fonts/Inter/Inter-SemiBold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("assets/fonts/Inter/Inter-SemiBoldItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("assets/fonts/Inter/Inter-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("assets/fonts/Inter/Inter-BoldItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("assets/fonts/Inter/Inter-ExtraBold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("assets/fonts/Inter/Inter-ExtraBoldItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("assets/fonts/Inter/Inter-Black.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("assets/fonts/Inter/Inter-BlackItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("assets/fonts/Fira-Code/FiraCode-Light.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("assets/fonts/Fira-Code/FiraCode-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("assets/fonts/Fira-Code/FiraCode-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("assets/fonts/Fira-Code/FiraCode-SemiBold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("assets/fonts/Fira-Code/FiraCode-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("assets/fonts/Fira-Code/FiraCode-VF.woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Inter";
  font-style: normal;
  font-weight: 100;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2");
}

@font-face {
  font-family: "Inter";
  font-style: italic;
  font-weight: 100;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2");
}

@font-face {
  font-family: "Inter";
  font-style: normal;
  font-weight: 200;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
}

@font-face {
  font-family: "Inter";
  font-style: italic;
  font-weight: 200;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
}

@font-face {
  font-family: "Inter";
  font-style: normal;
  font-weight: 300;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("woff2");
}

@font-face {
  font-family: "Inter";
  font-style: italic;
  font-weight: 300;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("woff2");
}

@font-face {
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("woff2");
}

@font-face {
  font-family: "Inter";
  font-style: italic;
  font-weight: 400;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("woff2");
}

@font-face {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("woff2");
}

@font-face {
  font-family: "Inter";
  font-style: italic;
  font-weight: 500;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("woff2");
}

@font-face {
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format("woff2");
}

@font-face {
  font-family: "Inter";
  font-style: italic;
  font-weight: 600;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("woff2");
}

@font-face {
  font-family: "Inter";
  font-style: normal;
  font-weight: 700;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format("woff2");
}

@font-face {
  font-family: "Inter";
  font-style: italic;
  font-weight: 700;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format("woff2");
}

@font-face {
  font-family: "Inter";
  font-style: normal;
  font-weight: 800;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format("woff2");
}

@font-face {
  font-family: "Inter";
  font-style: italic;
  font-weight: 800;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format("woff2");
}

@font-face {
  font-family: "Inter";
  font-style: normal;
  font-weight: 900;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_16___}) format("woff2");
}

@font-face {
  font-family: "Inter";
  font-style: italic;
  font-weight: 900;
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_17___}) format("woff2");
}

@font-face {
  font-family: "Fira Code";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_18___}) format("woff2");
  font-weight: 300;
  font-style: normal;
}

@font-face {
  font-family: "Fira Code";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_19___}) format("woff2");
  font-weight: 400;
  font-style: normal;
}

@font-face {
  font-family: "Fira Code";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_20___}) format("woff2");
  font-weight: 500;
  font-style: normal;
}

@font-face {
  font-family: "Fira Code";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_21___}) format("woff2");
  font-weight: 600;
  font-style: normal;
}

@font-face {
  font-family: "Fira Code";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_22___}) format("woff2");
  font-weight: 700;
  font-style: normal;
}

@font-face {
  font-family: "Fira Code VF";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_23___}) format("woff2-variations");
  /* font-weight requires a range: https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Fonts/Variable_Fonts_Guide#Using_a_variable_font_font-face_changes */
  font-weight: 300 700;
  font-style: normal;
}
`, "",{"version":3,"sources":["webpack://./node_modules/@nexthink/apollo-components/lib/fonts.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,4DAA+D;AACjE;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,4DAAqE;AACvE;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,4DAAqE;AACvE;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,4DAA2E;AAC7E;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,4DAAgE;AAClE;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,4DAAsE;AACxE;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,4DAAkE;AACpE;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,4DAAiE;AACnE;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,4DAAiE;AACnE;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,4DAAuE;AACzE;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,6DAAmE;AACrE;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,6DAAyE;AAC3E;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,6DAA+D;AACjE;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,6DAAqE;AACvE;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,6DAAoE;AACtE;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,6DAA0E;AAC5E;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,6DAAgE;AAClE;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,6DAAsE;AACxE;;AAEA;EACE,wBAAwB;EACxB,6DAAuE;EACvE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,6DAAyE;EACzE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,6DAAwE;EACxE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,6DAA0E;EAC1E,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,6DAAsE;EACtE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,wEAA+E;EAC/E,0JAA0J;EAC1J,oBAAoB;EACpB,kBAAkB;AACpB","sourcesContent":["@font-face {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 100;\n  font-display: swap;\n  src: url(\"assets/fonts/Inter/Inter-Thin.woff2\") format(\"woff2\");\n}\n\n@font-face {\n  font-family: \"Inter\";\n  font-style: italic;\n  font-weight: 100;\n  font-display: swap;\n  src: url(\"assets/fonts/Inter/Inter-ThinItalic.woff2\") format(\"woff2\");\n}\n\n@font-face {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 200;\n  font-display: swap;\n  src: url(\"assets/fonts/Inter/Inter-ExtraLight.woff2\") format(\"woff2\");\n}\n\n@font-face {\n  font-family: \"Inter\";\n  font-style: italic;\n  font-weight: 200;\n  font-display: swap;\n  src: url(\"assets/fonts/Inter/Inter-ExtraLightItalic.woff2\") format(\"woff2\");\n}\n\n@font-face {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 300;\n  font-display: swap;\n  src: url(\"assets/fonts/Inter/Inter-Light.woff2\") format(\"woff2\");\n}\n\n@font-face {\n  font-family: \"Inter\";\n  font-style: italic;\n  font-weight: 300;\n  font-display: swap;\n  src: url(\"assets/fonts/Inter/Inter-LightItalic.woff2\") format(\"woff2\");\n}\n\n@font-face {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 400;\n  font-display: swap;\n  src: url(\"assets/fonts/Inter/Inter-Regular.woff2\") format(\"woff2\");\n}\n\n@font-face {\n  font-family: \"Inter\";\n  font-style: italic;\n  font-weight: 400;\n  font-display: swap;\n  src: url(\"assets/fonts/Inter/Inter-Italic.woff2\") format(\"woff2\");\n}\n\n@font-face {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 500;\n  font-display: swap;\n  src: url(\"assets/fonts/Inter/Inter-Medium.woff2\") format(\"woff2\");\n}\n\n@font-face {\n  font-family: \"Inter\";\n  font-style: italic;\n  font-weight: 500;\n  font-display: swap;\n  src: url(\"assets/fonts/Inter/Inter-MediumItalic.woff2\") format(\"woff2\");\n}\n\n@font-face {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 600;\n  font-display: swap;\n  src: url(\"assets/fonts/Inter/Inter-SemiBold.woff2\") format(\"woff2\");\n}\n\n@font-face {\n  font-family: \"Inter\";\n  font-style: italic;\n  font-weight: 600;\n  font-display: swap;\n  src: url(\"assets/fonts/Inter/Inter-SemiBoldItalic.woff2\") format(\"woff2\");\n}\n\n@font-face {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 700;\n  font-display: swap;\n  src: url(\"assets/fonts/Inter/Inter-Bold.woff2\") format(\"woff2\");\n}\n\n@font-face {\n  font-family: \"Inter\";\n  font-style: italic;\n  font-weight: 700;\n  font-display: swap;\n  src: url(\"assets/fonts/Inter/Inter-BoldItalic.woff2\") format(\"woff2\");\n}\n\n@font-face {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 800;\n  font-display: swap;\n  src: url(\"assets/fonts/Inter/Inter-ExtraBold.woff2\") format(\"woff2\");\n}\n\n@font-face {\n  font-family: \"Inter\";\n  font-style: italic;\n  font-weight: 800;\n  font-display: swap;\n  src: url(\"assets/fonts/Inter/Inter-ExtraBoldItalic.woff2\") format(\"woff2\");\n}\n\n@font-face {\n  font-family: \"Inter\";\n  font-style: normal;\n  font-weight: 900;\n  font-display: swap;\n  src: url(\"assets/fonts/Inter/Inter-Black.woff2\") format(\"woff2\");\n}\n\n@font-face {\n  font-family: \"Inter\";\n  font-style: italic;\n  font-weight: 900;\n  font-display: swap;\n  src: url(\"assets/fonts/Inter/Inter-BlackItalic.woff2\") format(\"woff2\");\n}\n\n@font-face {\n  font-family: \"Fira Code\";\n  src: url(\"assets/fonts/Fira-Code/FiraCode-Light.woff2\") format(\"woff2\");\n  font-weight: 300;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"Fira Code\";\n  src: url(\"assets/fonts/Fira-Code/FiraCode-Regular.woff2\") format(\"woff2\");\n  font-weight: 400;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"Fira Code\";\n  src: url(\"assets/fonts/Fira-Code/FiraCode-Medium.woff2\") format(\"woff2\");\n  font-weight: 500;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"Fira Code\";\n  src: url(\"assets/fonts/Fira-Code/FiraCode-SemiBold.woff2\") format(\"woff2\");\n  font-weight: 600;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"Fira Code\";\n  src: url(\"assets/fonts/Fira-Code/FiraCode-Bold.woff2\") format(\"woff2\");\n  font-weight: 700;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"Fira Code VF\";\n  src: url(\"assets/fonts/Fira-Code/FiraCode-VF.woff2\") format(\"woff2-variations\");\n  /* font-weight requires a range: https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Fonts/Variable_Fonts_Guide#Using_a_variable_font_font-face_changes */\n  font-weight: 300 700;\n  font-style: normal;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
